import React, { Component } from 'react';

import './logo.css';

export default class Logo extends Component {

  render() {
    return <h1 className='ir logo'>The Higher Lower Game</h1>
  }
}


// WEBPACK FOOTER //
// ./src/components/logo/logo.js